const links = [
  {
    id: 0,
    title: 'UKG',
    path: 'https://bwc725-dl.ultipro.com/',
    info: 'UKG is your HR portal. Use it to request time off, view pay statements, update personal information, update direct deposit information, do open enrollment, and more...',
    benefit: '',
    phone: '(269) 795-3364 ext. 2024'
  },
  {
    id: 1, 
    title: 'Empower Health', 
    path: 'https://empower.health/bradfordwhite', 
    info: 'View your biometric and health assessment results here.',
    benefit: 'Benefit: Wellness Credit.',
    phone: ''
  },
  {
    id: 2, 
    title: 'Principal (401k)', 
    path: 'https://accounts.principal.com/app/bookmark/0oadm2qe1orihoKba5d7/login', 
    info: 'Access your 401k, pension, short-term disability, and long-term disability information here.',
    benefit: '',
    phone: ''
  },
  {
    id: 3, 
    title: 'Independence Blue Cross', 
    path: 'https://www.ibx.com/login', 
    info: 'View your benefit information, view eligibility and claim status, search for in-network providers, view your ID card and use the Care Cost Estimator.',
    benefit: 'Benefit: Medical.',
    phone: '(888) 356-7899'
  },
  {
    id: 4, 
    title: 'Navitus', 
    path: 'https://navitus.com/', 
    info: 'Find out if your drug is covered, see possible drug interactions, locate an in-network pharmacy, and access convenient tools to help lower your drug costs.',
    benefit: 'Benefit: Prescription Drug and Copay Assistance.',
    phone: '(844) 268-9789'
  },
  {
    id: 5, 
    title: 'HRAdministrators', 
    path: 'https://www.hradministrators.com/', 
    info: 'Visit \'Portal Links\' page to access your HSA/FSA. Visit \'Participants -> Forms \' to download a claim form to email to info@hradministrators.com.',
    benefit: 'Benefit: Health Savings Account (HSA), Flexible Savings Account (FSA), Dental, and Vision.',
    phone: '(800) 460-0738'
  },
  {
    id: 6, 
    title: 'Teladoc Health', 
    path: 'https://www.teladochealth.com/start?&utm_medium=paid&utm_source=tdh-bing-brand&utm_campaign=tdh-bing-brand-core-gen-alpha-lower-registration-web-22.12.25&utm_content=tdh-brand-evergreen-rsa-text-ad-22.12.25&utm_term=tdh-brand-teladoc-brand-exact-all-search-22.12.25&msclkid=1520f71ac2c31bd5b1e89ebd93b9ee22', 
    info: 'Access telemedicine doctors who can provide 24/7 access to care through an e-visit phone or video consultation.',
    benefit: 'Benefit: Telemedicine.',
    phone: '(800) 835-2362'
  },
  {
    id: 7, 
    title: 'MetLife', 
    path: 'https://www.metlife.com/', 
    info: 'Access your MyBenefits portal to submit claims and view your benefits.',
    benefit: 'Benefit: Life Insurance, Accidental Death and Dismemberment Insurance, Short Term Disability Insurance, and Long Term Disability Insurance.',
    phone: '(866) 492-6983'
  },
    {
    id: 8, 
    title: 'Telus Health', 
    path: 'https://www.telus.com/en/health', 
    info: 'EAP provides up to six free sessions per issue per year with an experienced consultant to help with a range of concerns and stressors at no cost to you.',
    benefit: 'Benefit: Employee Assistance Program (EAP)',
    phone: '(888) 851-7032'
  },
  {
    id: 9, 
    title: 'The Hartford', 
    path: 'https://www.thehartford.com/', 
    info: 'Submit claims through The Hartford if you pay for any of these benefits.',
    benefit: 'Benefit: Accident, Critical Illness, and Hospital Indemnity.',
    phone: '(866) 547-4205'
  },
  {
    id: 10, 
    title: 'Chubb',
    path: 'https://www.chubb.com/us-en/', 
    info: 'Access your Prevention & Early Detection, Cancer Management, and Recovery Benefits if you pay for this voluntary benefit.',
    benefit: 'Benefit: Cancer Advocate Plus.',
    phone: '(888) 449-0425'
  },
  {
    id: 11, 
    title: 'Dozuki',
    path: 'https://bockwaterheaters.dozuki.com/', 
    info: 'Access guides and wiki pages relevant to the assembly of our water heater products and components. Click here to access your training course as well.',
    benefit: '',
    phone: ''
  },

//   {id: -1, title: '', path: '', info: ''},
]

export default links